import { LANGUAGE } from "@root/constants";
import { getCurrentLanguage } from "@root/store/selectors/features";
import { updateLanguage } from "@root/store/slices/features";
import { changeAppLanguage } from "@root/utils/change-language";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import i18next from "i18next";

function useLanguage() {
  const currentLanguage = useSelector(getCurrentLanguage);
  const dispatch = useDispatch();

  const handleUpdateLanguage = (language: any) => {
    changeAppLanguage(language);
    dispatch(updateLanguage(language));
  };

  const toggleLanguage = () => {
    handleUpdateLanguage(
      currentLanguage === LANGUAGE.ENGLISH ? LANGUAGE.KOREAN : LANGUAGE.ENGLISH
    );
  };

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "appLanguage" && e.newValue) {
        const newLanguage = e.newValue.toUpperCase();
        if (newLanguage !== currentLanguage) {
          i18next.changeLanguage(e.newValue.toLowerCase());
          dispatch(updateLanguage(newLanguage));
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [currentLanguage, dispatch]);

  return {
    toggleLanguage,
    handleUpdateLanguage,
    currentLanguage,
    IsEnglishLanguage: currentLanguage === "EN",
  };
}

export default useLanguage;
